import React from "react";

const Tooltip = ({ children, type, data }) => {
    const totalIncrease =
        data
            .filter((obj) => obj.CARR > 0 && obj.name != "Existing" && obj.name != "Final")
            .reduce((sum, obj) => sum + obj.CARR, 0) * 1000;

    const totalDecrease =
        data
            .filter((obj) => obj.CARR < 0 && obj.name != "Existing" && obj.name != "Final")
            .reduce((sum, obj) => sum + obj.CARR, 0) * 1000;

    const carrChange = (data[data.length - 1].CARR - data[0].CARR) * 1000;

    return (
        <div className="group relative cursor-pointer">
            {children}
            <div className="absolute bottom-full z-10 hidden w-max max-w-xs rounded bg-white px-5 py-5 text-white shadow-lg group-hover:block">
                {type == "ending_carr" ? (
                    <div>
                        <p className="font-bold">Total Change in CARR:</p>
                        <p>${carrChange.toLocaleString()}</p>
                    </div>
                ) : (
                    <div>
                        <p className="font-bold">
                            {type === "decrease" ? "Total Decrease:" : "Total Increase:"}
                        </p>
                        <p style={{ color: type === "decrease" ? "#00b0f0" : "#e97132" }}>
                            $
                            {type === "decrease"
                                ? Math.abs(totalDecrease).toLocaleString()
                                : totalIncrease.toLocaleString()}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

const CustomLegend = ({ data }) => {
    return (
        <div className="flex flex-col items-center py-2">
            <div className="flex justify-center gap-4">
                <Tooltip type="ending_carr" data={data}>
                    <div className="flex items-center">
                        <div className="mr-1.5 h-3 w-3 bg-[#156082]" />
                        <span>Ending CARR</span>
                    </div>
                </Tooltip>

                <Tooltip type="increase" data={data}>
                    <div className="flex items-center">
                        <div className="mr-1.5 h-3 w-3 bg-[#e97132]" />
                        <span>Increase</span>
                    </div>
                </Tooltip>

                <Tooltip type="decrease" data={data}>
                    <div className="flex items-center">
                        <div className="mr-1.5 h-3 w-3 bg-[#00b0f0]" />
                        <span>Decrease</span>
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

export default CustomLegend;
